import React from "react";
import ArticleForm from "../components/ArticleForm";
import { useNavigate } from "react-router-dom";
import { ArticleService } from "../action";
import ROUTE_NAMES from "../../../routes/routeNames";

const AddArticles = () => {
  const navigate = useNavigate();

  return (
    <>
      <ArticleForm
        title="New draft"
        description="You're creating a new draft. It won't be visible to users until published."
        submitLabel="Save Article"
        initialTitle=""
        initialReadTime=""
        initialDescription=""
        submitHandler={async (values) => {
          const response = await ArticleService.addArticles(values);
          if (response) {
            navigate(ROUTE_NAMES.MAIN_ROUTES.ARTICLES);
          }
        }}
      />
    </>
  );
};

export default AddArticles;
